// extracted by mini-css-extract-plugin
export var TabItem = "index-module--TabItem--rMuGU";